/* import __COLOCATED_TEMPLATE__ from './service-charge-selector-field.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let ServiceChargeSelectorField = (_class = class ServiceChargeSelectorField extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isModalOpen", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  get serviceChargesLabel() {
    if (this.args.selectedServiceCharges.length === 0) {
      return this.intl.t('sharedUi.serviceCharges.none');
    } else if (this.args.selectedServiceCharges.length === 1) {
      const [serviceCharge] = this.args.selectedServiceCharges;
      return serviceCharge.name;
    } else if (this.args.selectedServiceCharges.length === this.args.serviceCharges.length) {
      return this.intl.t('sharedUi.serviceCharges.all');
    } else {
      return this.intl.t('sharedUi.serviceCharges.multiple', {
        count: this.args.selectedServiceCharges.length
      });
    }
  }
  get selectedServiceChargeIds() {
    return new Set(this.args.selectedServiceCharges.map(serviceCharge => serviceCharge.id));
  }
  get options() {
    return this.args.serviceCharges.map(this.createServiceChargeOption.bind(this));
  }
  get modalOptions() {
    return {
      title: this.intl.t('sharedUi.serviceCharges.modal.title'),
      selectAllLabel: this.intl.t('sharedUi.serviceCharges.all'),
      primaryButtonLabel: this.intl.t('sharedUi.common.done'),
      options: this.options,
      enableIndeterminateState: true,
      allowDisablingPrimaryButton: false
    };
  }
  open() {
    this.isModalOpen = true;
  }
  closeModal(event) {
    this.isModalOpen = false;
    if (!Array.isArray(event)) {
      return;
    }
    const selectedServiceChargeIds = event.reduce((selectedServiceChargeIds, {
      value,
      checked
    }) => {
      if (checked) {
        selectedServiceChargeIds.add(value);
      }
      return selectedServiceChargeIds;
    }, new Set());
    this.args.onChange(selectedServiceChargeIds);
  }
  createServiceChargeOption(serviceCharge) {
    return {
      label: serviceCharge.name,
      labelTertiary: serviceCharge.formattedAmount,
      value: serviceCharge.id,
      checked: this.selectedServiceChargeIds.has(serviceCharge.id)
    };
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _class);
export { ServiceChargeSelectorField as default };